<template>
  <div
    :class="DS_EMOJI_PICKER_CLASSES.Categories"
    role="group"
    :aria-label="CATEGORIES_LABEL"
    data-cy="ds-emoji-picker__categories"
  >
    <DSButton
      v-for="categoryItem in EMOJI_PICKER_CATEGORIES"
      :key="categoryItem.id"
      :variant="DS_BUTTON_VARIANT.Ghost"
      :size="DS_SIZE.Small"
      :class="[DS_EMOJI_PICKER_CLASSES.Category, { [DS_STATE_CLASSES.Selected]: categoryItem.id === modelValue }]"
      :aria-label="getEmojiPickerCategoryLabel(categoryItem.id)"
      :aria-pressed="categoryItem.id === modelValue"
      :data-cy="`ds-emoji-picker__category--${categoryItem.id}`"
      @click="modelValue = categoryItem.id"
    >
      {{ categoryItem.native || getEmojiPickerCategoryLabel(categoryItem.id) }}
    </DSButton>
  </div>
</template>

<script setup lang="ts">
import DSButton from "@/src/design_system/button_and_controls/button/components/DSButton.vue";
import { DS_BUTTON_VARIANT } from "@/src/design_system/button_and_controls/button/types/props";
import { EMOJI_PICKER_CATEGORIES } from "@/src/design_system/button_and_controls/emoji_picker/constants/categories";
import { DS_EMOJI_PICKER_CLASSES } from "@/src/design_system/button_and_controls/emoji_picker/constants/classes";
import { getEmojiPickerCategoryLabel } from "@/src/design_system/button_and_controls/emoji_picker/utils/categoryLabels";
import { DS_STATE_CLASSES } from "@/src/design_system/shared/constants/stateClasses";
import { DS_SIZE } from "@/src/design_system/shared/types/size";
import type { EmojiCategory } from "@/src/shared/emoji/types";

const modelValue = defineModel<EmojiCategory>({ required: true });

const CATEGORIES_LABEL = window.I18n.designSystem.emojiPicker.categoriesLabel;
</script>
